<template>
  <div class="container-customer-service">
    <div class="back"></div>
  </div>
</template>
<script>
import Client from '@/assets/scripts/client'

export default {
  components: {},
  props: {},
  data() {
    let query = this.$route.query
    return {
      autoSendContent: query.autoSendContent || null
    }
  },
  created() {
    if (this.autoSendContent && this.autoSendContent != null) {
      this.sendData()
    }
  },
  mounted() {
    // this.open()
    ssq.push('chatOpen')
  },
  methods: {
    // 上传数据
    sendData() {
      const app = Client.getAppInfo()
      ssq.push('setLoginInfo', {
        user_id: app.presentId, // 加密后的用户 id, 必填
        user_name: app.nickname, // 用户名， 必填
        language: app.language, // 插件语言， 选填
        email: app.email // 邮箱， 选填
      })
    },

    // 打开对话框
    open() {
      ssq.push('chatOpen')
    }
  },
  watch: {},
  computed: {},
  destroyed() {
    ssq.push('chatClose')
  }
}
</script>

<script>
// window.onload = function() {
//   ssq.push('chatOpen')
// }
</script>

<style lang="scss">
.container-customer-service {
  position: relative;
  // .back {
  //   position: absolute;
  //   z-index: 100 !important;
  //   width: 50px;
  //   height: 50px;
  //   background-color: #111;
  // }
}
</style>
